module.exports = __webpack_public_path__ + "static/media/personality-traits-ranking.33977adb.png";